export enum EnvEnum {
  Development = 'development',
  Testing = 'testing',
  Staging = 'staging',
  Production = 'production',
}
